import React from 'react';

export default class Timer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            time:0
        };
    }

    componentDidMount() {

    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        if(nextProps.tag === true && this.props.tag === false){
            this.startTimertick()
        }
    }

    startTimertick = () => {
        this.setTime(this.props.time)
        this.interval = setInterval(()=>{
            if(this.state.time <= 0){
                this.clearInterval()
                return
            }
            this.setTime(this.state.time - 1)
        },1000)
    }

    setTime = (time) => {
        this.setState({
            time
        })
    }

    stop = () => {
        this.setTime(0)
    }

    clearInterval = () => {
        this.props.reset()
        clearInterval(this.interval)
    }

    componentWillUnmount() {
        if(this.interval){
            clearInterval(this.interval)
        }
    }

    render() {
        return (
            <span style={this.props.style}>
                {
                    this.state.time > 0 ? <div>({this.state.time}s后重试)</div> : null
                }
            </span>
        );
    }
}